import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**
 * Os FormGroups da seção Pagamento (§8): um RECEBIMENTO com as suas PARCELAS dentro, e a linha
 * de RATEIO por centro de custo (§8.10).
 *
 * O documento soma recebimentos até cobrir o total, e cada um carrega o contexto da própria forma
 * — conta, intermediador, bandeira, categoria, condição e parcelas. É por isso que a forma
 * "Múltiplas" deixou de existir: vários meios são vários recebimentos.
 *
 * Os nomes dos controles são os das colunas de `venda_pagamento` e `venda_parcela`, porque o
 * contrato de gravação (`VendaPagamentoSalvarStruct`) é plano e espelha a tabela. O que é do
 * servidor (`idEmpresa`, `idVenda`, `datetimeInclusao`, `numeroParcela`) não tem controle: nasce lá.
 *
 * "Meio" (Banco × Intermediador) do Pix e do Boleto NÃO é controle: é derivável — intermediador
 * preenchido é Intermediador, senão Banco — e a tela o guarda como estado de UI enquanto edita.
 */
export function montarFormRecebimento(fb: FormBuilder): FormGroup {
    return fb.group({
        idVendaPagamento: [0],
        sequencia: [0],

        /** Quanto DESTE recebimento cobre do total. A soma de todos fecha o documento. */
        valor: [null as number | null, Validators.min(0)],
        idFormaRecebimento: [null as number | null],

        // Ou do cadastro de Finanças, ou digitada livremente — nunca as duas (§8.5).
        idCondicaoPagamento: [null as number | null],
        condicaoPagamentoLivre: [null as string | null],

        idCategoria: [null as number | null],

        // Conta bancária, caixa e de recebimento são a MESMA tabela em Finanças.
        idContaFinanceira: [null as number | null],
        idIntermediadorPagamento: [null as number | null],
        idIntermediadorBandeira: [null as number | null],

        // Vazia nas formas à vista e nos cartões: grade só onde há condição (§8.2).
        parcelas: fb.array([]),
    });
}

export function montarFormParcela(fb: FormBuilder): FormGroup {
    return fb.group({
        idVendaParcela: [0],
        numeroParcela: [0],
        dias: [null as number | null, Validators.min(0)],
        dataVencimento: [null as string | Date | null, Validators.required],
        valor: [0 as number, Validators.min(0)],

        // Sem esta flag a redistribuição automática (§8.7) não é reproduzível depois de reabrir:
        // "editar a última parcela redistribui o saldo entre as anteriores QUE AINDA NÃO FORAM
        // FIXADAS MANUALMENTE".
        isValorFixadoUsuario: [false],

        // [PED] Código de autenticação da transação, para conciliação. Não existe no Orçamento.
        nsu: [null as string | null],
        observacao: [null as string | null, Validators.maxLength(500)],
    });
}

export function montarFormRateio(fb: FormBuilder): FormGroup {
    return fb.group({
        idVendaRateioCentroCusto: [0],
        idCentroCusto: [null as number | null, Validators.required],
        valor: [null as number | null, Validators.min(0)],
        percentual: [null as number | null, [Validators.min(0), Validators.max(100)]],
    });
}
